import { getAuth } from 'firebase/auth'
import { getJWT } from '../util/jwt_helper'
declare global {
  interface Window {
    getToken:any
    getAuthToken : any
  }
}
function setupAuth() {
  window.getToken = () => {
    return getAuth().currentUser?.getIdToken()
  }
  window.getAuthToken = async (isNew : boolean = false)=>{
    return await getJWT(isNew)
  }
}

export { setupAuth }
